/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Delete_Confirm_CancelInputs */

const he_notifications_delete_confirm_cancel = /** @type {(inputs: Notifications_Delete_Confirm_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ביטול`)
};

const en_notifications_delete_confirm_cancel = /** @type {(inputs: Notifications_Delete_Confirm_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Notifications_Delete_Confirm_CancelInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_delete_confirm_cancel = /** @type {((inputs?: Notifications_Delete_Confirm_CancelInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Delete_Confirm_CancelInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_delete_confirm_cancel(inputs)
	return en_notifications_delete_confirm_cancel(inputs)
});